// Keputusan murni buat interaksi chart. Sengaja NOL IMPORT biar bisa dijalanin
// langsung pakai node.

// Domain selebar nol bikin skala d3 bagi nol.
function ensureWidth(low, high, fallbackMax) {
  if (high > low) return [low, high];
  return [low, low + (Number(fallbackMax) || 1)];
}

// Seri yang lagi ditampilin. `hidden` objek { [nama]: true }.
export function visibleDatasets(datasets, hidden) {
  const off = hidden || {};
  return (datasets || []).filter((d) => d && !off[d.name]);
}

// Domain satu sumbu dari seri yang dikirim. Nol selalu termasuk, dan nilai
// negatif melebarkan ke bawah.
export function domainFor(datasets, axis, fallbackMax) {
  const value = [];
  (datasets || []).forEach((d) => {
    if (d && d.axis === axis && d.interpolated) {
      (d.interpolated || []).forEach((v) => {
        if (typeof v === 'number' && Number.isFinite(v)) value.push(v);
      });
    }
  });
  if (value.length === 0) return ensureWidth(0, 0, fallbackMax);
  let min = value[0];
  let max = value[0];
  for (let i = 1; i < value.length; i += 1) {
    if (value[i] < min) min = value[i];
    if (value[i] > max) max = value[i];
  }
  return ensureWidth(Math.min(0, min), Math.max(0, max), fallbackMax);
}

// Domain yang dikunci menang atas hasil hitung ulang.
export function resolveDomain(locked, computed) {
  return Array.isArray(locked) && locked.length === 2 ? locked : computed;
}

// Seberapa jauh nol duduk dari dasar, 0..1. Dipakai buat nyamain garis nol.
function zeroRatio(domain) {
  if (!Array.isArray(domain) || domain.length !== 2) return 0;
  const [min, max] = domain;
  if (![min, max].every((v) => typeof v === 'number' && Number.isFinite(v))) return 0;
  const span = max - min;
  if (span <= 0 || min >= 0) return 0;
  return -min / span;
}

// Sumbu-sumbu di satu chart beda satuan, jadi angka min-nya gak bisa disamain.
// Yang disamain posisi garis nol-nya: sumbu yang nolnya paling tinggi jadi
// patokan, sumbu lain min-nya diturunin sampai nolnya sejajar. Nilai minus gak
// kepotong, dasar chart-nya jadi rata.
export function alignZeroBaseline(domains) {
  const list = domains || [];
  const deepest = list.reduce((acc, d) => Math.max(acc, zeroRatio(d)), 0);
  // deepest >= 1 = seluruh sumbu ada di bawah nol; gak ada yang bisa disejajarin.
  if (deepest <= 0 || deepest >= 1) return list.map((d) => d);
  return list.map((d) => {
    if (!Array.isArray(d) || d.length !== 2) return d;
    const [min, max] = d;
    if (![min, max].every((v) => typeof v === 'number' && Number.isFinite(v))) return d;
    if (zeroRatio(d) >= deepest) return [min, max];
    // (0 - newMin) / (max - newMin) = deepest
    const newMin = (deepest * max) / (deepest - 1);
    return [Math.min(min, newMin), max];
  });
}

// Rentang zoom setelah dinormalkan dan dijepit ke batas data. Balikin null
// kalau gak masuk akal — pemanggil pakai rentang penuh.
export function clampRange(range, extent) {
  if (!Array.isArray(range) || !Array.isArray(extent)) return null;
  const [a, b] = range;
  const [lo, hi] = extent;
  if (![a, b, lo, hi].every((v) => typeof v === 'number' && Number.isFinite(v))) return null;
  const start = Math.max(Math.min(a, b), Math.min(lo, hi));
  const end = Math.min(Math.max(a, b), Math.max(lo, hi));
  if (!(end > start)) return null;
  return [start, end];
}

function sel(value) {
  if (typeof value === 'number' && !Number.isFinite(value)) return '';
  const text = value === null || value === undefined ? '' : String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

// CSV dari apa yang lagi tampil. `formatTs` dikirim pemanggil supaya waktunya
// ikut zona browser, bukan UTC.
export function toCsv({ timestamps = [], datasets = [], formatTs }) {
  const title = ['time'].concat(datasets.map((d) => sel(d.name))).join(',');
  const row = timestamps.map((ts, i) => [sel(formatTs(ts))]
    .concat(datasets.map((d) => sel((d.data || [])[i])))
    .join(','));
  return `${[title].concat(row).join('\n')}\n`;
}
